// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_lp-5";
export var filledCircle = "_lp-4";
export var historyEntry = "_lp-3";
export var messageSideLeft = "_lp-1";
export var messageSideRight = "_lp-2";
export var orderTrackingCarouselWrapper = "_lp-6";
export var orderTrackingInfoContainer = "_lp-0";